import { requestJson } from '../../../shared/api/http'
import { type PostsQuery, type PostDto, type SocialPlatform } from '../model/contracts'
import { decodePostsResponse } from './postsCodec'
import { buildPostsQueryParams } from './postsQueryParams'

type PostsResult = {
  items: PostDto[]
  total?: number
  platform?: SocialPlatform
}

export async function fetchPosts(
  query: PostsQuery,
  signal?: AbortSignal,
): Promise<PostsResult> {
  const params = buildPostsQueryParams(query)
  const suffix = params.toString()
  const json = await requestJson<unknown>(`/api/v1/posts${suffix ? `?${suffix}` : ''}`, {
    method: 'GET',
    signal,
  })
  return decodePostsResponse(json)
}
